module.exports = __webpack_public_path__ + "img/thumbnail_WesternChimpanzee_f_albino.c36fa89d.png";